// extracted by mini-css-extract-plugin
var _1 = "Textarea__Textarea___Va8ja";
var _2 = "Textarea__count___JZIfD";
var _3 = "Textarea__show-count___BpNm2";
var _4 = "Textarea__wiggle___Z6DYB";
export { _1 as "Textarea", _2 as "count", _3 as "show-count", _4 as "wiggle" }
